module.exports = __webpack_public_path__ + "static/media/21.3e3d3057.mp4";